{
  "title": "รับของฝากขาย",
  "intro": "เลือกผู้ฝาก ใส่การ์ดทีละใบ แล้วกดปุ่มเดียว การ์ดยังไม่ขายจนกว่าจะทำหน้าสินค้าให้เสร็จ",
  "load_failed": "เปิดรอบรับของนี้ไม่ได้",
  "steps": {
    "label": "ขั้นตอน",
    "consignor": "ผู้ฝาก",
    "cards": "การ์ด",
    "review": "ตรวจและรับฝาก"
  },
  "consignor": {
    "search": "หาผู้ฝาก",
    "search_hint": "ชื่อ, คานะ, เลข CON- หรืออีเมล",
    "results": "ผู้ฝากที่พบ",
    "none": "ไม่พบ",
    "create": "เพิ่มผู้ฝากใหม่",
    "load_failed": "โหลดข้อมูลผู้ฝากไม่ได้",
    "change": "เปลี่ยนคน",
    "location": "ร้านที่รับของ",
    "location_hint": "เก็บการ์ดที่ร้านนี้ และบันทึกใน 古物台帳 ของร้านนี้",
    "start": "เริ่มรับของ"
  },
  "block": {
    "kyc_missing": "คนนี้ยังไม่ได้ทำ 本人確認",
    "kyc_missing_why": "古物営業法: ร้านต้องตรวจบัตรประจำตัวของทุกคนที่นำของมือสองมาให้ ก่อนรับของ",
    "kyc_pending": "本人確認 รอการยืนยัน",
    "kyc_pending_why": "ยืนยันการตรวจที่หน้าผู้ฝากก่อน (古物営業法)",
    "kyc_expired": "本人確認 ของคนนี้หมดอายุแล้ว",
    "kyc_expired_why": "古物営業法: ใช้การตรวจที่หมดอายุไม่ได้ ต้องทำ 本人確認 ใหม่ก่อนรับการ์ด",
    "kyc_rejected": "本人確認 ครั้งล่าสุดไม่ผ่าน",
    "kyc_rejected_why": "古物営業法: ทำ 本人確認 ใหม่ด้วยบัตรที่ร้านรับได้",
    "suspended": "ผู้ฝากคนนี้ถูกพักไว้",
    "suspended_why": "เปิดหน้าผู้ฝากเพื่อดูเหตุผลและเปิดใช้อีกครั้ง",
    "closed": "ผู้ฝากคนนี้ปิดแล้ว",
    "closed_why": "ผู้ฝากที่ปิดแล้วฝากการ์ดใหม่ไม่ได้",
    "agreement": "ยังไม่ได้ลงชื่อสัญญาฝากขายฉบับปัจจุบัน",
    "agreement_why": "ผู้ฝากลงชื่อสัญญาครั้งเดียว หลังจากนั้นทุกรอบรับของใช้สัญญานี้",
    "do_check": "ทำ 本人確認 ตอนนี้",
    "record_agreement": "ลงชื่อฉบับที่ {{version}} ที่ร้านแล้ว",
    "open_consignor": "เปิดหน้าผู้ฝาก"
  },
  "kinds": {
    "raw_single": "การ์ด",
    "graded_single": "การ์ดเกรด",
    "sealed_product": "กล่องซีล"
  },
  "entry": {
    "title": "ใบที่ {{n}}",
    "kind": "เป็นของแบบไหน",
    "card": "สแกนหรือพิมพ์การ์ด",
    "title_label": "ชื่อบนป้าย",
    "title_hint": "เติมจากการ์ดที่เลือก แก้ได้ถ้าต้องการ",
    "quantity": "จำนวนกล่อง",
    "quantity_hint": "แต่ละกล่องได้ป้ายของตัวเอง",
    "weight": "น้ำหนักกล่อง",
    "weight_hint": "ชั่งตัวสินค้าเอง (กล่องตามสภาพ) ไม่รวมซองส่งหรือบับเบิล — ตอนคิดค่าส่งระบบจะบวกน้ำหนักวัสดุแพ็กของร้านให้เอง",
    "price": "ราคาขายที่ตกลงกัน",
    "price_help": "ราคาที่ลูกค้าจ่าย (税込) ที่ตกลงกับผู้ฝาก",
    "agreed_min": "ราคาต่ำสุดที่ผู้ฝากรับได้",
    "agreed_min_hint": "ไม่บังคับ ถ้าจะลดต่ำกว่านี้ต้องให้ผู้ฝากอนุมัติเสมอ",
    "commission": "ค่าคอมของร้าน",
    "commission_hint": "เว้นว่าง = {{percent}} % (ค่าปกติของผู้ฝากคนนี้)",
    "commission_hint_rule": "เว้นว่าง = ตามกฎค่าคอมของร้าน",
    "company": "บริษัทเกรด",
    "grade": "เกรด",
    "cert": "เลขใบรับรอง",
    "discount": "ลดราคาได้ (ไม่เกิน 10 %)",
    "discount_hint": "ผู้ฝากยอมให้ร้านลดราคาได้ไม่เกิน 10 % ตอนจัดโปร",
    "photos": "รูป (1–2 รูป)",
    "features": "ตำหนิ / จุดสังเกต",
    "features_hint": "บันทึกใน 古物台帳 เช่น \"มีรอยขีดเล็กด้านหลัง\"",
    "add": "เพิ่มการ์ดใบนี้",
    "enter_hint": "กด Enter เพื่อเพิ่มแล้วไปใบถัดไป"
  },
  "lines": {
    "caption": "การ์ดของรอบรับของนี้",
    "card": "การ์ด",
    "condition": "สภาพ",
    "price": "ราคาที่ตกลง",
    "terms": "เงื่อนไข",
    "status": "สถานะ",
    "remove": "ลบ",
    "remove_line": "ลบใบที่ {{n}}",
    "removed": "ลบแล้ว",
    "empty": "ยังไม่มีการ์ด เพิ่มใบแรกด้านล่าง",
    "min": "ต่ำสุด",
    "commission": "ค่าคอม {{percent}} %",
    "commission_default": "ค่าคอมปกติ",
    "discount_ok": "ลดได้ถึง {{percent}} %",
    "discount_no": "ไม่ให้ลด",
    "photos_one": "{{count}} รูป",
    "photos_other": "{{count}} รูป",
    "weight": "{{grams}} ก.",
    "pending": "ยังไม่ได้รับ",
    "created": "รับแล้ว",
    "failed": "รับไม่ได้"
  },
  "problems": {
    "title": "ใส่ชื่อการ์ด",
    "rank": "เลือก Rank A–D",
    "grading_company": "เลือกบริษัทเกรด",
    "grade": "เลือกเกรด",
    "cert": "ใส่เลขใบรับรอง",
    "quantity": "1 ถึง 50 กล่อง",
    "weight": "ใส่น้ำหนักเป็นกรัม (1 ถึง 100,000)",
    "price": "ใส่ราคาเป็นเยน",
    "agreed_min": "ใส่ราคาต่ำสุดเป็นเยน",
    "agreed_min_above": "ราคาต่ำสุดสูงกว่าราคาขาย",
    "commission": "ตัวเลข 0 ถึง 100",
    "photos": "ไม่เกิน 10 รูป",
    "photos_busy": "รอให้อัปโหลดรูปเสร็จก่อน",
    "reason": "เขียนเหตุผลสั้นๆ",
    "fix_first": "แก้ช่องที่ขึ้นสีแดงก่อน"
  },
  "summary": {
    "agreement": "สัญญาฉบับที่ {{version}}",
    "so_far_one": "ตอนนี้ {{count}} ใบ",
    "so_far_other": "ตอนนี้ {{count}} ใบ",
    "next": "ตรวจและรับฝาก",
    "cards": "การ์ด",
    "total": "ราคาที่ตกลงรวม (税込)",
    "what_happens": "เมื่อกดรับฝาก ระบบจะสร้างสินค้าแบบร่าง (ยังไม่ขาย) ให้การ์ดทุกใบ บันทึก 古物台帳 รายการรับเข้า และเพิ่มเข้าสต็อก จากนั้นพิมพ์ 委託契約書 / 預り証 (2 ฉบับ) และป้ายราคา",
    "back": "กลับไปที่การ์ด",
    "complete": "受付する · รับฝาก"
  },
  "done": {
    "title_one": "รับการ์ด {{count}} ใบแล้ว",
    "title_other": "รับการ์ด {{count}} ใบแล้ว",
    "toast_one": "รับการ์ด {{count}} ใบแล้ว",
    "toast_other": "รับการ์ด {{count}} ใบแล้ว",
    "some_failed": "รับแล้ว {{created}} ใบ, รับไม่ได้ {{failed}} ใบ",
    "what_happened": "บันทึกใน 古物台帳 และสต็อกแล้ว ยังไม่ขาย เปิดการ์ดแต่ละใบเพื่อทำหน้าสินค้าให้เสร็จ",
    "retry": "ลองการ์ดที่เหลืออีกครั้ง",
    "documents": "委託契約書 / 預り証",
    "documents_pending": "กำลังทำ 委託契約書…",
    "documents_failed": "ยังทำ 委託契約書 ไม่ได้ ระบบจะลองใหม่เอง",
    "documents_unavailable": "ระบบยังทำ 委託契約書 / 預り証 ไม่ได้ (แบบฟอร์มยังไม่พร้อม) ตอนนี้ให้ใช้แบบฟอร์มกระดาษไปก่อน — การรับฝากบันทึกแล้ว",
    "documents_todo": "เปิดรายการสิ่งที่ต้องทำ",
    "document_n": "เอกสาร {{n}}",
    "labels": "พิมพ์ป้าย",
    "to_items": "ดูการ์ดเหล่านี้",
    "again": "รับการ์ดของคนนี้ต่อ",
    "ledger_one": "บันทึก 古物台帳 รายการรับเข้า {{count}} แถวแล้ว",
    "ledger_other": "บันทึก 古物台帳 รายการรับเข้า {{count}} แถวแล้ว",
    "ledger_open": "เปิด 古物台帳"
  },
  "cancel": {
    "button": "ยกเลิกรอบนี้",
    "title": "ยกเลิกรอบรับของนี้?",
    "consequence": "ยังไม่ได้รับอะไร การ์ดที่พิมพ์ไว้จะหายไป",
    "confirm": "ยกเลิกรอบรับของ",
    "done": "ยกเลิกแล้ว",
    "already": "รอบรับของนี้ถูกยกเลิกแล้ว",
    "new": "เริ่มรอบใหม่"
  },
  "board": {
    "intro": "การ์ดฝากขายทั้งหมดตามสถานะ ลากการ์ดเพื่อตรวจ พัก หรือปิด สถานะอื่นเปลี่ยนเอง",
    "new_intake": "รับของฝากขาย",
    "drafts_one": "มีรอบรับของที่ยังไม่เสร็จ {{count}} รอบ:",
    "drafts_other": "มีรอบรับของที่ยังไม่เสร็จ {{count}} รอบ:",
    "draft_cards_one": "{{count}} ใบ",
    "draft_cards_other": "{{count}} ใบ",
    "views": "วิธีแสดงการ์ด",
    "tab_board": "บอร์ด",
    "tab_list": "ตาราง",
    "tab_prices": "ราคารอยืนยัน",
    "only_of": "เฉพาะการ์ดของ",
    "show_all": "ทุกคน",
    "search": "ค้นการ์ด",
    "search_hint": "ชื่อ, รหัสป้าย หรือเลขใบรับรอง",
    "drag_hint": "แตะการ์ดเพื่อดูรายละเอียด ใช้คีย์บอร์ด: เปิดการ์ดแล้วกดปุ่มในนั้น",
    "locked": "เปลี่ยนเอง",
    "auto_listed": "เมื่อหน้าสินค้าเปิดขาย",
    "auto_reserved": "ระหว่างที่ออเดอร์ของลูกค้าจองไว้",
    "auto_sold": "เมื่อลูกค้าจ่ายเงิน",
    "auto_returned": "เมื่อคืนให้ผู้ฝากแล้ว",
    "refuse_automatic": "\"{{stage}}\" เปลี่ยนอัตโนมัติ (เมื่อขายได้ เปิดขาย หรือคืนของ) เลือกเองไม่ได้",
    "refuse_not_from_here": "จากสถานะตอนนี้ เปลี่ยนเป็น \"{{stage}}\" ไม่ได้"
  },
  "list": {
    "reference": "รหัสป้าย",
    "card": "การ์ด",
    "stage": "สถานะ",
    "consignor": "ผู้ฝาก",
    "received": "วันที่รับ"
  },
  "item": {
    "title": "การ์ดฝากขาย",
    "load_failed": "โหลดการ์ดนี้ไม่ได้",
    "intake": "รอบรับ {{reference}} ใบที่ {{line}}",
    "price": "ราคาขาย",
    "payout": "ผู้ฝากได้ (ประมาณ)",
    "finish_product": "ทำหน้าสินค้าให้เสร็จ",
    "open_product": "เปิดหน้าสินค้า",
    "create_product": "สร้างสินค้าอีกครั้ง",
    "retried": "กำลังลองใหม่",
    "discount_title": "ส่วนลด",
    "discount": "ร้านลดราคาได้ไม่เกิน {{percent}} %",
    "discount_reason": "เปลี่ยนที่หน้าการ์ดฝากขาย",
    "discount_locked": "ตอนนี้ผู้ฝากเท่านั้นที่เปลี่ยนได้ (ตัวเลือกในพอร์ทัลของผู้ฝาก)",
    "status_title": "สถานะ",
    "moved": "เปลี่ยนเป็น {{stage}} แล้ว",
    "notes": "โน้ต",
    "save_notes": "บันทึกโน้ต",
    "saved": "บันทึกแล้ว",
    "timeline": "ประวัติ",
    "actor_staff": "พนักงาน",
    "actor_consignor": "ผู้ฝาก",
    "actor_system": "อัตโนมัติ"
  },
  "move": {
    "to": {
      "received": "กลับไปเป็น \"รับแล้ว\"",
      "under_review": "ตรวจก่อน",
      "ready_to_list": "พร้อมขาย",
      "paused": "พักไว้",
      "closed": "ปิด"
    },
    "auto_listed": "กำลังขาย จะเปลี่ยนเองเมื่อลูกค้าสั่งหรือซื้อ",
    "auto_reserved": "อยู่ในออเดอร์ลูกค้า จะเปลี่ยนเองเมื่อจ่ายเงินหรือออเดอร์จบ",
    "auto_sold": "ขายแล้ว จะเปลี่ยนเองเมื่อจ่ายเงินผู้ฝาก",
    "auto_returned": "คืนผู้ฝากแล้ว",
    "auto_generic": "สถานะนี้เปลี่ยนเอง",
    "confirm_title": "เปลี่ยนเป็น \"{{stage}}\"?",
    "confirm_consequence": "ผู้ฝากจะเห็นสถานะใหม่ในพอร์ทัล",
    "confirm": "เปลี่ยน"
  },
  "price": {
    "change": "เปลี่ยนราคา",
    "new_title": "ขอเปลี่ยนราคาขาย",
    "new_intro": "ผู้ฝากอนุมัติราคาใหม่ในพอร์ทัล (หรืออนุมัติเองเมื่อครบจำนวนวันที่ผู้ฝากเลือก)",
    "current": "ราคาตอนนี้",
    "minimum": "ราคาต่ำสุดที่รับได้",
    "no_minimum": "ไม่ได้ตั้ง",
    "new_price": "ราคาใหม่",
    "reason": "เหตุผล",
    "below_min_warning": "ต่ำกว่าราคาต่ำสุดที่ผู้ฝากรับได้ จะไม่อนุมัติเอง",
    "how_it_works": "ราคาบนเว็บเปลี่ยนหลังผู้ฝากตอบตกลงเท่านั้น",
    "send": "ส่งให้ผู้ฝาก",
    "sent": "ส่งแล้ว ผู้ฝากจะเห็นในพอร์ทัล",
    "applied": "ขายด้วยราคาใหม่แล้ว",
    "open_title": "ราคารอคำตอบ",
    "waiting_consignor": "รอผู้ฝากตอบ",
    "waiting_staff": "ผู้ฝากรอคำตอบจากร้าน",
    "waiting_nobody": "ไม่มีอะไรต้องตอบ",
    "proposed_by_staff": "ร้านเสนอ",
    "proposed_by_consignor": "ผู้ฝากขอ",
    "counter_of": "ผู้ฝากตอบกลับเป็น",
    "below_min_note": "ต่ำกว่าราคาต่ำสุดที่ตกลงตอนรับของ",
    "needs_manager": "ลดราคามาก ต้องให้ผู้จัดการอนุมัติ",
    "auto_on": "อนุมัติเองวันที่",
    "note": "โน้ต",
    "note_hint": "ไม่บังคับ บันทึกไว้กับคำตอบ",
    "approve": "อนุมัติราคานี้",
    "approved": "อนุมัติแล้ว ขายด้วยราคาใหม่",
    "decline": "ปฏิเสธ",
    "declined": "ปฏิเสธแล้ว",
    "withdraw": "ถอนคำขอ",
    "withdrawn": "ถอนคำขอแล้ว",
    "close": "ปิด",
    "pending_line": "ราคารอคำตอบ:"
  },
  "prices": {
    "from": "ราคาตอนนี้",
    "to": "ราคาใหม่",
    "waiting": "ใครต้องตอบ",
    "waiting_staff": "ร้าน",
    "waiting_consignor": "ผู้ฝาก",
    "waiting_nobody": "ไม่มี",
    "since": "ตั้งแต่",
    "status": "สถานะ",
    "status_pending": "รอคำตอบ",
    "status_countered": "ผู้ฝากตอบกลับเป็นราคา",
    "status_approved": "อนุมัติ",
    "status_auto_approved": "อนุมัติเอง",
    "status_rejected": "ผู้ฝากไม่ตกลง",
    "status_expired": "หมดเวลา",
    "status_cancelled": "ถอนแล้ว",
    "view_open": "รอคำตอบ",
    "view_countered": "ผู้ฝากตอบกลับ"
  },
  "return": {
    "button": "คืนผู้ฝาก",
    "confirm_title": "คืนการ์ดใบนี้?",
    "confirm_consequence": "เอาออกจากเว็บทันที 古物台帳 รายการจ่ายออกบันทึกตอนส่งมอบหรือส่งไปรษณีย์",
    "confirm": "เริ่มคืนของ",
    "started": "เริ่มคืนของแล้ว เอาการ์ดออกจากเว็บแล้ว",
    "open_panel": "เปิดการ์ดเพื่อคืนของ",
    "title": "คืนของ {{reference}}",
    "status": {
      "requested": "มีคำขอ หยิบการ์ดออกจากตู้โชว์",
      "preparing": "กำลังหยิบออกจากตู้โชว์",
      "ready": "พร้อมแล้ว ส่งมอบที่ร้านหรือส่งไปรษณีย์",
      "handed_over": "ส่งมอบแล้ว",
      "handed_over_pending_inventory": "ส่งมอบแล้ว กำลังอัปเดตสต็อก",
      "shipped": "ส่งแล้ว",
      "shipped_pending_inventory": "ส่งแล้ว กำลังอัปเดตสต็อก",
      "cancelled": "ยกเลิกแล้ว"
    },
    "prepare": "กำลังหยิบออก",
    "ready": "พร้อมแล้ว",
    "at_shop": "ที่ร้าน",
    "signature": "รูปใบรับคืนที่เซ็นแล้ว",
    "hand_over": "ส่งมอบแล้ว",
    "by_post": "ส่งไปรษณีย์",
    "carrier": "บริษัทขนส่ง",
    "tracking": "เลขติดตาม",
    "ship": "ส่งแล้ว",
    "sync": "อัปเดตสต็อกอีกครั้ง",
    "slip": "返還受領書",
    "cancel": "ยกเลิกการคืน",
    "cancel_consequence": "การ์ดกลับไปสถานะเดิม",
    "saved": "บันทึกแล้ว",
    "done_preparing": "กำลังหยิบออก",
    "done_ready": "พร้อมแล้ว แจ้งผู้ฝากแล้ว",
    "done_handed_over": "ส่งมอบแล้ว บันทึกใน 古物台帳 แล้ว",
    "done_shipped": "ส่งแล้ว บันทึกใน 古物台帳 แล้ว",
    "done_cancelled": "ยกเลิกการคืนแล้ว"
  },
  "requests": {
    "title": "คำขอฝากขาย",
    "intro": "คนที่ขอฝากขายผ่านเว็บ ติดต่อแล้วรับ (สร้างผู้ฝาก + รอบรับของ) หรือปฏิเสธ",
    "reference": "เลขที่",
    "name": "ชื่อ",
    "cards": "การ์ด",
    "status_col": "สถานะ",
    "received": "ได้รับเมื่อ",
    "status": {
      "new": "ใหม่",
      "contacted": "ติดต่อแล้ว",
      "accepted": "รับแล้ว",
      "rejected": "ปฏิเสธ",
      "converted": "สร้างผู้ฝากแล้ว"
    },
    "view_new": "ใหม่",
    "view_contacted": "ติดต่อแล้ว",
    "load_failed": "โหลดคำขอนี้ไม่ได้",
    "language": "ภาษา",
    "asking": "ราคาที่อยากได้",
    "notes": "โน้ตของร้าน",
    "note": "โน้ต",
    "note_hint": "บันทึกไว้กับคำขอ (ไม่ส่งให้ลูกค้า)",
    "accept": "รับและเตรียมรอบรับของ",
    "contacted": "ติดต่อแล้ว",
    "reject": "ปฏิเสธ",
    "reject_hint": "เมื่อปฏิเสธ ระบบส่งอีเมลสุภาพเป็นภาษาของลูกค้า",
    "saved": "บันทึกแล้ว",
    "done_contacted": "ตั้งเป็นติดต่อแล้ว",
    "done_rejected": "ปฏิเสธแล้ว กำลังส่งอีเมล",
    "open_intake": "เปิดรอบรับของ",
    "convert_title": "รับคำขอ",
    "convert_intro": "ตรวจการ์ดแต่ละใบ: เป็นอะไร, Rank A–D หรือเกรด และราคาที่ตกลง 本人確認 และสัญญาทำตอนรับของ",
    "convert": "สร้างผู้ฝากและรอบรับของ",
    "card_n": "ใบที่ {{n}}"
  }
}
